import { Grid } from '@farewill/ui'

import InputFloating from 'components/form/input-floating'
import { formatCurrency } from 'lib/formatting/currency'
import { ProbateEstateItem } from 'lib/models/probate-estate'
import { OTHER_BILL_SCHEMA } from 'lib/probate/estate-questionnaire-schema'
import { getItemsTotals } from 'routes/probate-estate/fact-find/get-totals'

import RecordsSection, {
  RecordsSubSectionProps,
} from '../../estate/records-section'

// no utilityType is what makes an item an other bill rather than a utility,
// so new ones are created as they are. Who the bill is from is saved as
// description, the field the quote and old fact-find use, so debts entered
// there show their name here
const OtherBills = ({
  collection,
  sectionActive,
  saveProbateEstateField,
}: RecordsSubSectionProps) => {
  // the same sum as the quote, so old fact-find debts recorded as joint count
  // only the deceased's share
  const { total } = getItemsTotals(collection.items as ProbateEstateItem[])
  const isNothingOwed = total === formatCurrency({ value: 0 })
  // debts reduce the estate, so show them as negative - unless nothing is owed
  const debtTotal = isNothingOwed ? total : `-${total}`

  return (
    <RecordsSection
      heading="3.3 Other bills"
      cardType="Other bill"
      addLabel="Add other bill"
      toggleName="otherBillsSectionActive"
      sectionActive={sectionActive}
      saveProbateEstateField={saveProbateEstateField}
      collection={collection}
      schema={OTHER_BILL_SCHEMA}
      totals={{ total: debtTotal }}
      renderFields={({ handleSave, pairedFieldSpan }) => (
        <>
          <Grid.Item span={12}>
            <InputFloating
              name="description"
              label="Who is the bill from?"
              handleSave={handleSave}
            />
          </Grid.Item>
          <Grid.Item span={pairedFieldSpan}>
            <InputFloating
              name="referenceNumber"
              label="Account or reference number"
              handleSave={handleSave}
            />
          </Grid.Item>
          <Grid.Item span={pairedFieldSpan}>
            <InputFloating
              name="value"
              label="Amount owed (£)"
              isCurrency
              handleSave={handleSave}
            />
          </Grid.Item>
        </>
      )}
    />
  )
}

export default OtherBills
